"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingStateLatestVerificationApi = exports.bookingStateApi = void 0;
const handlers_1 = require("../handlers");
exports.bookingStateApi = (http, prefix = '/booking-state') => ({
    getStateEventStreamByEventId(propertyId, eventId) {
        return http.get(`${prefix}/property/${propertyId}/event/${eventId}/state_events`);
    },
    postStateEventStreamByEventId(propertyId, eventId, bookingStateEvents) {
        return http.post(`${prefix}/property/${propertyId}/event/${eventId}/state_events`, bookingStateEvents);
    },
    submitOverrides(propertyId, eventId, overrides) {
        return http.post(`${prefix}/property/${propertyId}/event/${eventId}/state/overrides`, overrides);
    }
});
exports.bookingStateLatestVerificationApi = (http, prefix = '/booking-state') => ({
    getStateEventLatestVerificationByEventId(propertyId, eventId) {
        return http.get(`${prefix}/property/${propertyId}/event/${eventId}/state/latest_verification_state`)
            .catch(handlers_1._404({}))
            .then((resp) => resp);
    }
});
//# sourceMappingURL=index.js.map